import { useEffect, useState } from "react";
import PageHero from "@/components/PageHero";
import RoomCard from "@/components/RoomCard";
import CTABanner from "@/components/CTABanner";
import { api } from "@/lib/api";

export default function Rooms() {
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    document.title = "Rooms & Accommodation | Sagar Darshan Guest House, Somnath";
    api.rooms().then(setRooms).catch(() => {});
  }, []);

  return (
    <div data-testid="rooms-page">
      <PageHero overline="Accommodation" title="Our Rooms"
        image="https://customer-assets-gfyr7b9c.emergentagent.net/job_somnath-coastal-stay/artifacts/rku99we2_IMG_0892.jpeg" />
      <section className="mx-auto max-w-7xl px-5 py-24 lg:px-10 lg:py-32">
        <p className="max-w-2xl leading-relaxed text-navy/70">
          Every room at Sagar Darshan faces the Arabian Sea. Choose from comfortable standard rooms, sea-facing accommodation with panoramic views, or a spacious executive suite for the family.
        </p>
        <div className="mt-14 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {rooms.map((room, i) => <RoomCard key={room.id} room={room} index={i} />)}
        </div>
        <p className="mt-12 text-xs text-navy/40">
          Tariff shown is per night and inclusive of all applicable taxes, as per Shree Somnath Trust.
        </p>
      </section>
      <CTABanner />
    </div>
  );
}
